export default __webpack_public_path__ + "static/media/intro6.eaea59a5.png";